/**
 * Product card touch behavior: pressing a card previews its second image
 * (`.is-touch-preview`), releasing restores the first, and a normal tap
 * navigates to the product as usual (we never call preventDefault, so the
 * native click on the <a> proceeds).
 */
const clear = () => {
  document.querySelectorAll('.product-card.is-touch-preview').forEach((card) => {
    card.classList.remove('is-touch-preview');
  });
};

document.addEventListener(
  'touchstart',
  (event) => {
    const card = event.target.closest('.product-card');
    if (card && card.querySelector('.product-card__image--hover')) {
      card.classList.add('is-touch-preview');
    }
  },
  { passive: true }
);

['touchend', 'touchcancel'].forEach((type) => {
  document.addEventListener(type, clear, { passive: true });
});
